/**
 * perf-deferred-scripts.js
 * MavenUp Performance Optimization — June 2026
 * Defers non-critical third-party scripts until after page is interactive.
 * Loads: Facebook Pixel, TikTok Pixel tracking events after 3 seconds idle
 * or on first user interaction (whichever comes first).
 */
(function () {
  'use strict';

  var loaded = false;

  function loadDeferredScripts() {
    if (loaded) return;
    loaded = true;

    // Signal to any analytics wrappers that deferred load has happened
    window.dispatchEvent(new CustomEvent('perf:deferred-scripts-loaded'));
  }

  // Load on first user interaction
  var interactionEvents = ['mouseover', 'keydown', 'touchstart', 'scroll', 'click'];
  interactionEvents.forEach(function (evt) {
    document.addEventListener(evt, loadDeferredScripts, { once: true, passive: true });
  });

  // Fallback: load after 4 seconds regardless
  setTimeout(loadDeferredScripts, 4000);

  // Lazy-load video elements that are set to autoplay
  // Replaces autoplay with click-to-play for off-screen videos
  function deferOffscreenVideos() {
    if (!('IntersectionObserver' in window)) return;

    var videos = document.querySelectorAll('video[autoplay], video[data-autoplay]');
    if (!videos.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          // Resume video when it enters viewport
          if (video.paused && video.dataset.deferredAutoplay) {
            video.play().catch(function () {});
          }
          observer.unobserve(video);
        }
      });
    }, { rootMargin: '200px' });

    videos.forEach(function (video) {
      // Only defer videos that are NOT in the hero (first visible section)
      var heroSection = video.closest('[data-section-type="hero"], [data-section-type="slideshow"]');
      var isHero = heroSection && heroSection.getBoundingClientRect().top < window.innerHeight;

      if (!isHero) {
        video.dataset.deferredAutoplay = 'true';
        video.removeAttribute('autoplay');
        video.pause();
        observer.observe(video);
      }
    });
  }

  // Run video deferral after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', deferOffscreenVideos);
  } else {
    deferOffscreenVideos();
  }

})();
